import { useApp } from '@hb/react'
import { EncounterStatus, getEncounterStatusLabel } from '@hb/shared'

// Thin wrapper over the shared, app-split status-label helper (§1.6 / §6.4.1). Reads the current
// app so callers don't have to thread `appName` — the billing-facing admin app shows
// "Saved — Ready for Auth" for COMPLETED; the providers app keeps "Completed".
export const useEncounterStatusLabel = (status: EncounterStatus): string => {
  const { appName } = useApp()
  return getEncounterStatusLabel(status, appName)
}
